// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: who may open Team insights, and which view a /insights path shows.

export type InsightsTabId = 'overview' | 'people' | 'schedule' | 'suggestions' | 'feedback' | 'agents' | 'machines';

export interface InsightsView {
	tab: InsightsTabId;
	/** Set on /insights/people/:userId. */
	personId: string | null;
}

/** Staff only. Unknown (not loaded yet) counts as no. */
export function canSeeInsights(user: {isStaff(): boolean} | null | undefined): boolean {
	return user?.isStaff() === true;
}

/**
 * The view for a pathname, or null when it is not a Team insights path.
 * Unknown tab names fall back to the overview.
 */
export function parseInsightsPath(pathname: string): InsightsView | null {
	const trimmed = pathname.replace(/\/+$/, '');
	if (trimmed !== '/insights' && !trimmed.startsWith('/insights/')) return null;
	const parts = trimmed.split('/').slice(2).filter(Boolean);
	if (parts[0] === 'people' && parts[1]) {
		let personId = parts[1];
		try {
			personId = decodeURIComponent(personId);
		} catch {
			// keep the raw segment
		}
		return {tab: 'people', personId};
	}
	const tab = parts[0];
	if (
		tab === 'people' ||
		tab === 'schedule' ||
		tab === 'suggestions' ||
		tab === 'feedback' ||
		tab === 'agents' ||
		tab === 'machines'
	)
		return {tab, personId: null};
	return {tab: 'overview', personId: null};
}
